module.exports = edap;


//////////////////
// WEBPACK FOOTER
// external "edap"
// module id = R/0D
// module chunks = 2